import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check, Loader2, X } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { API, http } from "@/lib/api";
import { Logo } from "@/components/site/Logo";

const Shell = ({ children }) => (
  <div className="min-h-screen bg-[#0A0A0C] flex items-center justify-center px-5 grain">
    <div className="glass-card max-w-lg w-full p-10 md:p-14 text-center">
      <Logo className="h-12 w-12 mx-auto mb-8" />
      {children}
    </div>
  </div>
);

export const PaymentSuccess = () => {
  const { t } = useLang();
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");
  useEffect(() => {
    const sid = params.get("session_id");
    let n = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await http.get(`${API}/payments/status/${sid}`);
        if (data?.payment_status === "paid") { setState("ok"); return; }
      } catch (e) { /* keep polling */ }
      n += 1;
      if (n >= 10) setState("fail");
      else timer = setTimeout(poll, 2000);
    };
    if (sid) poll(); else setState("fail");
    return () => clearTimeout(timer);
  }, [params]);

  return (
    <Shell>
      <div data-testid="payment-success-page">
        {state === "checking" && <><Loader2 className="mx-auto animate-spin text-[#E5C158]" /><p className="mt-6 text-zinc-300">{t.pay.checking}</p></>}
        {state === "ok" && <>
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-[#C5A059] text-[#E5C158]"><Check /></span>
          <h1 className="mt-6 font-display text-4xl text-[#F9F9F9]" data-testid="payment-status-ok">{t.pay.ok}</h1>
          <p className="mt-4 text-zinc-300">{t.pay.okSub}</p></>}
        {state === "fail" && <h1 className="font-display text-3xl text-[#F9F9F9]" data-testid="payment-status-fail">{t.pay.fail}</h1>}
        <Link to="/" className="btn-gold mt-10 inline-flex" data-testid="payment-home-btn">{t.pay.home}</Link>
      </div>
    </Shell>
  );
};

export const PaymentCancel = () => {
  const { t } = useLang();
  return (
    <Shell>
      <div data-testid="payment-cancel-page">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-white/20 text-zinc-300"><X /></span>
        <h1 className="mt-6 font-display text-4xl text-[#F9F9F9]">{t.pay.cancel}</h1>
        <p className="mt-4 text-zinc-300">{t.pay.cancelSub}</p>
        <Link to="/" className="btn-gold mt-10 inline-flex" data-testid="payment-cancel-home-btn">{t.pay.home}</Link>
      </div>
    </Shell>
  );
};
